<script>
import { capitalize } from "@/services/helper";
import { getProgramStatusText } from "@/services/program-status";
import programPatientService from "@/services/programPatient";

export default {
  name: "ModalAdditionalInformation",

  props: {
    showDialogModal: {
      type: Boolean,
      default: false,
    },
    programPatient: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isPosting: false,
      message: "",
    };
  },

  computed: {
    formsCount() {
      const forms = this.programPatient?.program?.initialData;
      return Array.isArray(forms) ? forms.length : 0;
    },
    patientLabel() {
      const patient = this.programPatient?.patient;
      if (!patient) return "-";
      return (
        capitalize(patient.firstName) + " " + capitalize(patient.lastName) ||
        "-"
      );
    },
    programLabel() {
      const program = this.programPatient?.program;
      if (!program) return "-";
      return program.name;
    },
    statusLabel() {
      const status = this.programPatient?.status;
      if (!status) return "-";
      return getProgramStatusText(status);
    },
    canSubmit() {
      return !!(this.message && this.message.trim().length);
    },
  },

  methods: {
    close() {
      this.isPosting = false;
      this.$emit("close");
    },

    submit() {
      if (this.isPosting) return;
      this.isPosting = true;
      const id = this.programPatient && this.programPatient._id;
      programPatientService
        .requestAdditionalInformation(id, this.message)
        .then((updated) => {
          this.$emit("submit", {
            message: this.message,
            context: { programPatient: updated },
          });
          this.$message({ type: "success", message: "Solicitud enviada" });
          this.close();
        })
        .catch(() => {
          this.isPosting = false;
        });
    },
  },
};
</script>

<template lang="pug">
  el-dialog(name="modal-additional-information", :visible.sync="showDialogModal", :before-close="close", :title="'Solicitar información adicional'")
    .el-dialog__body.modal-additional-information__body
      .mb-2(v-if="programPatient")
        .mb-1
          small.text-muted Paciente: 
            strong {{ patientLabel }}
        .mb-1
          small.text-muted Programa: 
            strong {{ programLabel }}
        .mb-1
          small.text-muted Formularios relacionados: 
            strong {{ formsCount }}
        .mb-1
          small.text-muted Estado del programa: 
            strong {{ statusLabel }}

      label.label Detalle
        ValidationProvider(name="Detalle" rules="required" v-slot="{ errors }")
          el-input(v-model="message" type="textarea" :autosize="{minRows: 4, maxRows: 8}" placeholder="Escriba aquí la información solicitada...")
          span.has-error {{ errors[0] }}

    .el-dialog__footer
      el-button(type="primary" :disabled="!canSubmit" :loading="isPosting" @click="submit") Enviar
</template>

<style lang="scss" scoped>
.modal-additional-information__body {
  padding: 0 20px 20px 20px;
}
.mb-2 {
  margin-bottom: 20px;
}
</style>
